import {Component, inject, input} from '@angular/core';
import {ListBulletIconComponent} from '@core/svg-icons/list-bullet-icon.component';
import {UserCircleIconComponent} from '@core/svg-icons/user-circle-icon.component';
import {UserService} from '@core/services/user.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {HeartEmptyIconComponent} from '@core/svg-icons/heart-empty-icon.component';
import {StarEmptyIconComponent} from '@core/svg-icons/star-empty-icon.component';

@Component({
  selector: 'app-user-universe-menu',
  templateUrl: './user-universe-menu.component.html',
  styleUrls: ['./user-universe-menu.component.scss'],
  imports: [
    ListBulletIconComponent,
    UserCircleIconComponent,
    HeartEmptyIconComponent,
    StarEmptyIconComponent
  ]
})

export class UserUniverseMenuComponent {
  modalService = inject(NgbModal);
  protected router = inject(Router);
  private userService = inject(UserService);


  loading = input(false);

  goToOrderHistory() {
    if (this.loading()) {
      return;
    }
    this.router.navigateByUrl('/kundeportal/ordrehistorik');
    this.modalService.dismissAll();
  }

  goToMyProfile() {
    if (this.loading()) {
      return;
    }
    this.router.navigateByUrl('/kundeportal/profil');
    this.modalService.dismissAll();
  }

  goToFavorites() {
    if (this.loading()) {
      return;
    }
    this.router.navigateByUrl('/kundeportal/favoritter');
    this.modalService.dismissAll();
  }

  goToRatings() {
    if (this.loading()) {
      return;
    }
    this.router.navigateByUrl('/kundeportal/ratings');
    this.modalService.dismissAll();
  }

  logout() {
    if (this.loading()) {
      return;
    }
    this.userService.logout();
    this.modalService.dismissAll();
    import('../../modals/logout-modal/logout-modal.component').then(comp => {
      this.modalService.open(comp.LogoutModalComponent);
    })
  }
}
